import React, { useState } from "react";

const InputTextBox = (props) => {
    const { formInputsProps } = props
    const [textbox, setTextbox] = useState(null);
    return (
        <div className="col-12 form-group">
            <label> {formInputsProps?.formField?.is_mandatory ? '*' : null} {formInputsProps?.formField?.input} </label>
            <input type="text" name={formInputsProps?.formField?.input} required={false} value={formInputsProps.formValues[formInputsProps?.formField?.input] = textbox} onChange={ data => setTextbox(data.target.value) } placeholder="Type here..."/>
            {
                formInputsProps.formValues[formInputsProps.formField?.input] && !formInputsProps.formErrors[formInputsProps.formField?.input] ? null : 
                <p className="errMsg">{formInputsProps.formErrors[formInputsProps.formField?.input]}</p>
            }
        </div>
    )
}

export default InputTextBox